import { message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { Link, useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    _id: String
    user1: number
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const CampaignsTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });



    function p(total: number | null, val: number | null) {
        if (total == null || val == null) return "-"
        if (total == 0) return "-"
        return (val + " (" + Math.floor((val * 100) / total) + "%)")
    }

    const columns: ColumnsType<DataType> = [
        {
            sorter: true, title: 'شروع', dataIndex: 'step1', key: 'step1', width: 170,
            render(val) {
                if (!val) return
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            sorter: true, title: 'نوتیف تخفیف', dataIndex: 'step2', key: 'step2', width: 170,
            render(val) {
                if (!val) return
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

        {
            sorter: true, title: 'تخفیف sms', dataIndex: 'step3', key: 'step3', width: 170,
            render(val) {
                if (!val) return
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

        {
            sorter: true, title: 'پایان', dataIndex: 'step4', key: 'step4', width: 170,
            render(val) {
                if (!val) return
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

        {
            sorter: true, title: 'شروع', dataIndex: 'user1', key: 'user1', width: 120,
            render(val, all) {
                return p(val, val)
            },
        },
        {
            sorter: true, title: 'نوتیف تخفیف', dataIndex: 'user2', key: 'user2', width: 120,
            render(val, all) {
                return p(all.user1, val)
            },
        },
        {
            sorter: true, title: 'تخفیف sms', dataIndex: 'user3', key: 'user3', width: 120,
            render(val, all) {
                return p(all.user1, val)
            },
        },
        {
            sorter: true, title: 'پایان', dataIndex: 'user4', key: 'user4', width: 120,
            render(val, all) {
                return p(all.user1, val)
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/campaigns/paginate`, { params: { ...params, ...filters } })
            .then((res) => {
                const result = res.data.result
                setItems(result.campaigns);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.campaignsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default CampaignsTable


